import { render, staticRenderFns } from "./updateThesisProposal.vue?vue&type=template&id=07fcb132&scoped=true"
import script from "./updateThesisProposal.vue?vue&type=script&lang=js"
export * from "./updateThesisProposal.vue?vue&type=script&lang=js"
import style0 from "./updateThesisProposal.vue?vue&type=style&index=0&id=07fcb132&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fcb132",
  null
  
)

export default component.exports